export enum Locale {
  EN = 'en',
  ES = 'es',
}

export const AVAILABLE_LANGUAGES = [
  { code: Locale.EN, lang: 'English' },
  { code: Locale.ES, lang: 'Español' },
] as const
